export default __webpack_public_path__ + "static/media/xmost_innovative_company-0104-1.png.pagespeed.ic.JnIyPDbpmj.f263d848.png";